import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import ButtonComponent from '@/components/Button';
import { ReactComponent as CheckCircleFilledIcon } from '@/assets/images/icons/check-circle-filled.svg';
import { GlobalContext } from '@/contexts/GlobalContext';

import './finish.scss';
import { useTranslation } from 'react-i18next';

function Finish({ setModalOpen, requestId }) {
  const { t } = useTranslation();
  const { setTriggerFetchProfile } = useContext(GlobalContext);

  useEffect(() => {
    // Trigger call api get profile to update available sms credit
    setTriggerFetchProfile(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="finish-container">
      <div className="content-wrap">
        <div className="icon">
          <CheckCircleFilledIcon />
        </div>
        <div className="title">
          {t('sms_create_new_request.success_code.SMS_SENDING_SUCCESS.title')}
        </div>
        <div className="description">
          {t('sms_create_new_request.success_code.SMS_SENDING_SUCCESS.title', {
            requestId,
          })}
        </div>
        <div className="actions">
          <ButtonComponent type="default" onClick={() => setModalOpen(false)}>
            {t('sms_create_new_request.close')}
          </ButtonComponent>
        </div>
      </div>
    </div>
  );
}

Finish.propTypes = {
  setModalOpen: PropTypes.func,
  requestId: PropTypes.string,
};

export default Finish;
